import type { VesselMessage } from '../../../../../types/VesselMessage';
import { translate } from '../../../../common/helpers/translate.helper';
import { useCustomerDetails } from '../../../../common/hooks/useCustomerDetails';
import { FormikVesselSelect } from '../../../FormikVesselSelect';

interface TargetVesselSelectProps {
    sourceVessel: VesselMessage;
}

export const TargetVesselSelect = ({ sourceVessel }: TargetVesselSelectProps) => {
    const sourceCustomerQuery = useCustomerDetails(sourceVessel.customerId);

    return (
        <FormikVesselSelect
            name="targetVesselId"
            label={translate('vessel.migration.targetVessel')}
            caption={
                sourceCustomerQuery.isError
                    ? translate('vessel.migration.sourceCustomerError')
                    : translate('vessel.migration.targetVesselCaption')
            }
            imo={sourceVessel.imo}
            groupId={sourceCustomerQuery.data?.customerGroupId}
            disabled={!sourceCustomerQuery.data}
        />
    );
};
